"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import Columns, { Column } from "@/components/common/Columns";
import Branding from "@/components/site/Branding";
import Credits from "@/components/site/Credits";
import Nav from "@/components/site/Nav";
import styles from "./Footer.module.css";

export interface FooterProps extends HTMLProps<HTMLDivElement> {};

export default function Footer({
	className
} : FooterProps) {
	return (
		<footer
			id="footer"
			className={cn(
				styles.Footer,
				className
			)}
		>
			<div
				className={styles.FooterInner}
			>
				<Columns>
					<Column
						className={styles.FooterColumnBranding}
					>
						<Branding />
					</Column>
					<Column
						className={styles.FooterColumnNav}
					>
						<Nav />
					</Column>
				</Columns>
				<Columns>
					<Column
						className={styles.FooterColumnSocial}
					>
					</Column>
					<Column
						className={styles.FooterColumnCredits}
					>
						<Credits />
					</Column>
				</Columns>
			</div>
		</footer>
	);
}